import {JsonProperty} from '@hyperloris/tyson';

export class Login {
  @JsonProperty()
  login: string = '';
  @JsonProperty()
  password: string = '';
}
